/*
 * Hands the loader's bird to the gate. The loader records where its bird was (and which
 * wing frame it showed) as it unmounts; the gate takes that and carries on flying from
 * exactly there, so the two screens read as one scene.
 */
let handoff = null;

export const saveBirdHandoff = (data) => {
  handoff = { ...data, at: performance.now() };
};

/**
 * The saved hand-off, if it is fresh (the gate mounts right after the loader goes). It is
 * not cleared on reading, so React's dev double-invoke of initialisers can't lose it;
 * a stale one is ignored.
 */
export const takeBirdHandoff = () => (handoff && performance.now() - handoff.at < 8000 ? handoff : null);
